<template>
  <div class="card">
    <div class="search-box">
      <span class="header">供应商信息</span>
      <div class="item">
        <span><label>供应商账号名：</label>{{c.alias}}</span>
        <span><label>供应商账号：</label>{{c.account}}</span>
      </div>
      <div class="item"><label>{{$route.query.title}}：</label>{{c.frozenAmount||c.accountCost||'0'}}&nbsp元</div>
    </div>
    <div class="list" style="background:rgba(255,255,255,1); padding:24px">
      <span class="header">相关订单</span>
      <order-list :data="data" :pagination="pagination" :orderType="orderType"></order-list>
    </div>
  </div>
</template>
<script>
import OrderList from "@/components/OrderList";
export default {
  name:'fundlist',
  components:{OrderList},
  data() {
    return {
      c:{},
      data:[],
      pagination: {
        total:0,
        current:1,
        pageSize:10,
        onChange: page => {
          this.pagination.current = page;
          this.getdata && this.getdata();
        },
      },
    };
  },
  computed:{
    orderType(){
      let orderType = ""
      let title = this.$route.query.title;
      if (title == "冻结资金") {
        orderType = "5";
      }else if (title == "已用资金") {
        orderType = "6";
      }
      return orderType;
    }
  },
  activated(){
    let meta = this.$route.meta;
    if (!meta.keepAlive) {
      this.pagination.current = 1;
      this.getdata()
    }
 }, 
 beforeRouteEnter(to,from,next){
    if(from.name !== 'order-advance'){//不是从detail页面过来的，需要刷新
        to.meta.keepAlive = false;
    }else{
      to.meta.keepAlive = true;
    }
    next()
},
 beforeRouteLeave(to,from,next){
    if(to.name !== 'order-advance') {//不去详情页面时，将缓存的listData数组清空
        this.data = []
    }
    next()
},
  methods:{
    reset(){
      this.searchTerm = {};
      this.getdata();
    },
    getdata(){
      let params = {
        pageNum : this.pagination.current,
        supplierId :this.$route.query.id,
      }
      const title = this.$route.query.title;
      let   url = ''
      if (title == '冻结资金') {
        url = 'supplyCost/queryFrozenAmountOrder'
      } else if(title == '已用资金'){
        url = 'supplyCost/queryAccountCostOrder'
      }
      this.$http.post(url,'',{params}).then(res=>{
        if (res.result) {
          this.data = res.rows
          this.c = res.data;
          this.pagination.total = res.count;
        } 
      })
    },
  }
};
</script>
<style lang="less" scoped>
.list{
  .header{
    display: inline-block;
    font-size:16px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(0,0,0,0.85);
    line-height:24px;
    margin-bottom: 16px;
  }
}
.card{
  margin:0 24px;
}
/deep/.ant-list-lg .ant-list-item {
    padding-top: 0;
}
.search-box{
  background:rgba(255,255,255,1);
  label{
    display:inline-block;
    width: 98px;
    text-align: right;
  }
  .header{
    font-size:16px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(0,0,0,0.85);
    line-height:24px;
  }
  span{
      display: inline-block;
      padding: 8px 0 ;
    }
  .item{
    span{
      padding-right:180px;
    }
  } 
}
.ant-list-split .ant-list-item {
    border: 1px solid #e8e8e8;
    margin-bottom: 12px;
}
/deep/.ant-list-split .ant-list-header {
    margin-bottom: 12px;
    background-color: #FAFAFA;
}
.order-detail{
    display: flex;
    align-items: center;
}
</style>
